export default [{
  textId: 'car_condition_query_scratches',
  icons: [{
    name: 'attentionFilled',
    color: 'primaryLight2'
  }, {
    name: 'approved',
    color: 'whatsapp'
  }, {
    name: 'approved',
    color: 'whatsapp'
  }]
}, {
  textId: 'car_condition_query_upholstery',
  icons: [{
    name: 'attentionFilled',
    color: 'primaryLight2'
  }, {
    name: 'approved',
    color: 'whatsapp'
  }, {
    name: 'approved',
    color: 'whatsapp'
  }]
}, {
  textId: 'car_condition_query_electronics',
  icons: [{
    name: 'attentionFilled',
    color: 'primaryLight2'
  }, {
    name: 'attentionFilled',
    color: 'primaryLight2'
  }, {
    name: 'approved',
    color: 'whatsapp'
  }]
}];